module.exports = __webpack_public_path__ + "537a5fcb29f080235d720547b7916a0c.png";